class TabSwitcher {
    constructor(switcher, options = {}) {
        // string selector or HTMLElement
        if (typeof switcher === 'string') {
            this.switcherElement = document.querySelector(switcher);
        }
        else {
            this.switcherElement = switcher;
        }
        if (!this.switcherElement) {
            throw new Error('Switcher element not found');
        }
        // default options
        this.options = Object.assign({ activeClass: 'active', onChange: () => { } }, options);
        // use parent element
        this.parent = this.options.parentElement ||
            (options.parentElement ? options.parentElement : this.switcherElement.parentElement || document);
        this.init();
    }
    init() {
        const tabButtons = this.switcherElement.querySelectorAll('[data-tab]');
        // set initial tab if set
        if (this.options.initialTab) {
            this.switchTab(this.options.initialTab);
        }
        else {
            if (tabButtons.length > 0) {
                const firstTab = tabButtons[0].getAttribute('data-tab');
                if (firstTab) {
                    this.switchTab(firstTab);
                }
            }
        }
        // event listeners
        tabButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                event.preventDefault(); // Prevent form submission
                const tabName = button.getAttribute('data-tab');
                if (tabName) {
                    this.switchTab(tabName);
                }
            });
        });
    }
    switchTab(tabName) {
        var _a, _b;
        // update tab buttons
        const tabButtons = this.switcherElement.querySelectorAll('[data-tab]');
        tabButtons.forEach(button => {
            if (button.getAttribute('data-tab') === tabName) {
                button.classList.add(this.options.activeClass);
            }
            else {
                button.classList.remove(this.options.activeClass);
            }
        });
        // update tab content
        const tabContents = this.parent.querySelectorAll(`[data-tab-target]`);
        tabContents.forEach(content => {
            const tabTargets = content.getAttribute('data-tab-target');
            if (tabTargets) {
                const categories = tabTargets.split(',').map(cat => cat.trim());
                // show content if contains target category
                if (categories.includes(tabName)) {
                    content.classList.add(this.options.activeClass);
                }
                else {
                    content.classList.remove(this.options.activeClass);
                }
            }
        });
        // onChange callback
        (_b = (_a = this.options).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, tabName);
    }
    getActiveTab() {
        const activeButton = this.switcherElement.querySelector(`.${this.options.activeClass}[data-tab]`);
        return (activeButton === null || activeButton === void 0 ? void 0 : activeButton.getAttribute('data-tab')) || null;
    }
    destroy() {
        const tabButtons = this.switcherElement.querySelectorAll('[data-tab]');
        tabButtons.forEach(button => {
            button.removeEventListener('click', () => { });
        });
    }
}
export default TabSwitcher;
